import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../../../components/form/button/button";
import { sendFeedback } from "../redux/AISagas";

const content = {
  positive: {
    title: "Thanks for feedback!",
    content:
      "Glad this answer worked well for you. Tell us what you liked most so we can keep improving."
  },
  negative: {
    title: "Help us improve",
    content:
      "Sorry this answer missed the mark. Share what didn’t work so we can do better next time."
  }
};

const FeedbackPopover = ({ anchorRef, onClose, onSubmit, feedback, pageName, id }) => {
  const popoverRef = useRef(null);
  const dispatch = useDispatch();
  const [style, setStyle] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");

  useEffect(() => {
    if (!anchorRef?.current) return;

    const rect = anchorRef.current.getBoundingClientRect();

    setStyle({
      top: rect.top - 8,
      left: rect.left + rect.width / 2
    });

    const handleClickOutside = (event) => {
      if (
        !popoverRef.current?.contains(event.target) &&
        !anchorRef.current?.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", onClose, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", onClose, true);
    };
  }, [anchorRef]);

  const handleSubmit = () => {
    if (!id) return;

    dispatch(sendFeedback({ id, feedback, pageName, feedbackText }));
    onSubmit();
  };

  if (!style) return null;

  return (
    <div
      className="feedback-popover"
      ref={popoverRef}
      style={{ top: style.top, left: style.left }}
      data-testid="feedback-popover"
    >
      <div className="feedback-popover__container">
        <div className="feedback-popover__title">{content[feedback].title}</div>

        <div className="feedback-popover__content">{content[feedback].content}</div>

        <textarea
          className="feedback-popover__textarea"
          placeholder="Write your feedback here..."
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
        />

        <div className="feedback-popover__actions">
          <Button text="Submit Feedback" disabled={!feedbackText.trim()} onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

export default FeedbackPopover;
